import { UPDATE_ORGANIZATION_CONTEXT } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const updateOrganizationContext = orgId => ({
  type: UPDATE_ORGANIZATION_CONTEXT,
  payload: { orgId },
});
